import React, {useRef, useEffect} from 'react';
import {FastField, ErrorMessage} from 'formik';
import classNames from 'classnames';
import get from 'lodash/get';
import messages from '../../../../res/translations/messages';
import {FormattedMessage} from 'react-intl';
import Error from '../../Error';

const MappSendProviderParams = ({errors, touched, values, setFieldValue, validationSchema}) => {
    const lastProvider = useRef(values.sendProvider);

    useEffect(() => {
        if (lastProvider.current !== values.sendProvider) {
            lastProvider.current = values.sendProvider;
            setFieldValue('sendProviderParams', {
                invitationEmailMessageId: values.sendProviderParams.invitationEmailMessageId || '',
                reminderEmailMessageId: values.sendProviderParams.reminderEmailMessageId || '',
                invitationSMSMessageId: values.sendProviderParams.invitationSMSMessageId || '',
                reminderSMSMessageId: values.sendProviderParams.reminderSMSMessageId || '',
            });
        }
    }, [values.sendProvider, values.sendProviderParams, setFieldValue, validationSchema]);


    return <div className={classNames('col', 'send-provider-params', 'mapp-send-provider-params')} >
        {/* <label className="col-form-label">
            <FormattedMessage {...messages.surveys.form.label.sendProviderParams.mapp.title} />
        </label> */}
        <div>
            <label className="col-form-label">
                <FormattedMessage {...messages.surveys.form.label.sendProviderParams.mapp.email} />
            </label>
            <div className="row">
                <div className="col-md-6 col-6">
                    <div className="form-group">
                        <label className="col-form-label" htmlFor="sef_sendproviderparams_invitationemailmessageid">
                            <FormattedMessage {...messages.surveys.form.label.sendProviderParams.mapp.invitationMessageId} />
                        </label>
                        <FastField name="sendProviderParams.invitationEmailMessageId" >
                            {({field, form}) => (
                                <input
                                    {...field}
                                    id="sef_sendproviderparams_invitationemailmessageid"
                                    type="text"
                                    className={classNames('form-control',
                                        {error:
                                            get(errors, 'sendProviderParams.invitationEmailMessageId') &&
                                            get(touched, 'sendProviderParams.invitationEmailMessageId'),
                                        })}
                                    value={field.value || ''}
                                />
                            )}
                        </FastField>
                        <ErrorMessage name="sendProviderParams.invitationEmailMessageId">
                            {(message) => <Error reason={message.key} reasonParams={message.params} />}
                        </ErrorMessage>
                    </div>
                </div>
                <div className="col-md-6 col-6">
                    <div className="form-group">
                        <label className="col-form-label" htmlFor="sef_sendproviderparams_reminderemailrmessageid">
                            <FormattedMessage {...messages.surveys.form.label.sendProviderParams.mapp.reminderMessageId} />
                        </label>
                        <FastField name="sendProviderParams.reminderEmailMessageId" >
                            {({field, form}) => (
                                <input
                                    {...field}
                                    id="sef_sendproviderparams_reminderemailmessageid"
                                    type="text"
                                    className={classNames('form-control',
                                        {error:
                                            get(errors, 'sendProviderParams.reminderEmailMessageId') &&
                                            get(touched, 'sendProviderParams.reminderEmailMessageId'),
                                        })}
                                    value={field.value || ''}
                                />
                            )}
                        </FastField>
                        <ErrorMessage name="sendProviderParams.reminderEmailMessageId">
                            {(message) => <Error reason={message.key} reasonParams={message.params} />}
                        </ErrorMessage>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <label className="col-form-label">
                <FormattedMessage {...messages.surveys.form.label.sendProviderParams.mapp.sms} />
            </label>
            <div className="row">
                <div className="col-md-6 col-6">
                    <div className="form-group">
                        <label className="col-form-label" htmlFor="sef_sendproviderparams_invitationsmsmessageid">
                            <FormattedMessage {...messages.surveys.form.label.sendProviderParams.mapp.invitationMessageId} />
                        </label>
                        <FastField name="sendProviderParams.invitationSMSMessageId" >
                            {({field, form}) => (
                                <input
                                    {...field}
                                    id="sef_sendproviderparams_invitationsmsmessageid"
                                    type="text"
                                    className={classNames('form-control',
                                        {error:
                                            get(errors, 'sendProviderParams.invitationSMSMessageId') &&
                                            get(touched, 'sendProviderParams.invitationSMSMessageId'),
                                        })}
                                    value={field.value || ''}
                                />
                            )}
                        </FastField>
                        <ErrorMessage name="sendProviderParams.invitationSMSMessageId">
                            {(message) => <Error reason={message.key} reasonParams={message.params} />}
                        </ErrorMessage>
                    </div>
                </div>
                <div className="col-md-6 col-6">
                    <div className="form-group">
                        <label className="col-form-label" htmlFor="sef_sendproviderparams_remindersmsrmessageid">
                            <FormattedMessage {...messages.surveys.form.label.sendProviderParams.mapp.reminderMessageId} />
                        </label>
                        <FastField name="sendProviderParams.reminderSMSMessageId" >
                            {({field, form}) => (
                                <input
                                    {...field}
                                    id="sef_sendproviderparams_remindersmsmessageid"
                                    type="text"
                                    className={classNames('form-control',
                                        {error:
                                            get(errors, 'sendProviderParams.reminderSMSMessageId') &&
                                            get(touched, 'sendProviderParams.reminderSMSMessageId'),
                                        })}
                                    value={field.value || ''}
                                />
                            )}
                        </FastField>
                        <ErrorMessage name="sendProviderParams.reminderSMSMessageId">
                            {(message) => <Error reason={message.key} reasonParams={message.params} />}
                        </ErrorMessage>
                    </div>
                </div>
            </div>
        </div>
    </div>;
};

export default MappSendProviderParams;
